import { render } from "./ProformaList.vue?vue&type=template&id=1aeb6426&scoped=true"
import script from "./ProformaList.vue?vue&type=script&lang=js"
export * from "./ProformaList.vue?vue&type=script&lang=js"

import "./ProformaList.vue?vue&type=style&index=0&id=1aeb6426&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aeb6426"]])

export default __exports__